import { Alert, InvoicesScheduleModule, QuoteTierModule, StepperFooter } from '@korint/folio';
import { useSuspenseQuery } from '@tanstack/react-query';
import { policyControllerListBranchesQueryOptions } from 'korint-sdk';
import { useAssertedParams } from '@folio/lib';
import { useTranslation } from 'react-i18next';

export function PolicyholderSummaryStep() {
  const { t } = useTranslation();
  const { policyId, branchId } = useAssertedParams();

  const { data: isCanceled } = useSuspenseQuery({
    ...policyControllerListBranchesQueryOptions(policyId),
    select: data => data.data?.find(({ id }) => id === branchId)?.branchStatus === 'BRANCH_CLOSED',
  });

  if (isCanceled) {
    return <Alert variant="destructive">{t('driverSummary.branchClosed')}</Alert>;
  }

  return (
    <div className="flex flex-col gap-4">
      <QuoteTierModule showModifyButton={false} />

      <InvoicesScheduleModule />

      <StepperFooter nextButtonEnabled />
    </div>
  );
}
